import { useRoutes,Navigate } from "react-router-dom";
import { protectedRoutes } from "./protected";
import { publicRoutes } from "./public";
import Landing from "../modules/landing";
import LiveMain from "../modules/live-main";
import useAppAccessor from "../hooks/useappAccessor";
import { useEffect } from "react";

export const AppRoutes = () => {
  //   const auth = useAuth();
  const { getUserData} = useAppAccessor();
  const { user } = getUserData()

  useEffect(()=>{
   // console.log("user===>IN Navigation",user)
  },[user])

  
  const commonRoutes = [{ path: "/", element: <Navigate to='/login'/> }];

  

  //   const routes = auth.user ? protectedRoutes : publicRoutes;
  // const routes = user.token ? protectedRoutes : publicRoutes;
  const routes = localStorage.getItem('jwt_token') ? protectedRoutes : publicRoutes;
  // const routes = publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
